import { App } from '@capacitor/app';
import { Capacitor, registerPlugin } from '@capacitor/core';
import store from '../../store';
import { history } from '../../views/App/history';
import {
  canPresentIncomingShare,
  createIncomingShareInbox,
  handleIncomingShare,
  isIncomingShareUrl
} from './incoming-share';

const ShareInbox = registerPlugin('ShareInbox');

let started = false;

export const consumeIncomingShare = id => {
  if (!Capacitor.isNativePlatform()) {
    return Promise.resolve();
  }
  return ShareInbox.consume({ id });
};

export const startIncomingShareInbox = () => {
  if (started || !Capacitor.isNativePlatform()) {
    return;
  }
  started = true;

  let pull = () => {};
  const inbox = createIncomingShareInbox({
    getPending: () => ShareInbox.getPending(),
    addListener: async deliver => {
      try {
        await ShareInbox.addListener('shareReceived', deliver);
      } catch (error) {
        // The listener is missing until this binary is installed.
      }
      App.addListener('appUrlOpen', event => {
        if (isIncomingShareUrl(event.url)) {
          pull();
        }
      }).catch(() => {});
    },
    // Fires when a custom-icon share brings the app forward without a share event.
    subscribeActive: refresh => {
      App.addListener('appStateChange', state => {
        if (state && state.isActive) {
          refresh();
        }
      }).catch(() => {});
    },
    subscribeSession: onSession => {
      store.subscribe(onSession);
      history.listen(onSession);
    },
    hasSession: () => canPresentIncomingShare(store.getState(), history.location.pathname),
    onShare: share => {
      const dropped = handleIncomingShare(share);
      dropped.forEach(item => {
        if (item && item.id) {
          Promise.resolve(consumeIncomingShare(item.id)).catch(() => {});
        }
      });
    },
    onDismiss: share => {
      if (share && share.id) {
        Promise.resolve(consumeIncomingShare(share.id)).catch(() => {});
      }
    }
  });
  pull = () => {
    inbox.pull();
  };

  inbox.start().catch(() => {});
};
